import styled, { css } from "styled-components";

export const Container = styled.div`
  max-width: 100%;

  @media (min-width: 768px) {
    max-width: 460px;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem;
  margin-top: 1rem;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
`;

export const TitleForm = styled.span`
  ${({ theme }) => css`
    margin-top: 0.5rem;
    font-size: 1.25rem;
    display: flex;
    justify-content: center;
    color: ${theme.colors.primary};
  `}
`;

export const Form = styled.form`
  @media (min-width: 768px) {
    max-height: calc(100vh - 250px);
    overflow-y: auto;
  }
`;

export const ContentCalendar = styled.div`
  padding: 1rem 0 0.5rem;
`;

export const ContentForm = styled.div`
  padding: 0 1.5rem;

  > div + div {
    margin-top: 0.5rem;
  }

  > div + button {
    margin-top: 1rem;
  }
`;

export const WrapperAccessPermissions = styled.div`
  margin-top: 1rem;
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 1rem;
`;

export const ContentSubmitButton = styled.div`
  margin-top: 1.5rem;
`;
